import { createSelector } from 'reselect';
import get from 'lodash/get';
import { applicationPropertiesSelector as propertiesSelector } from './properties';

export const applicationServersSelector = createSelector(
  [propertiesSelector],
  // eslint-disable-next-line no-bitwise
  ({ setup }) => ({
    vod: get(setup, 'servers.vod', process.env.VOD_BASE_URL),
    channels: get(setup, 'servers.channels', process.env.CHANNELS_API_BASE_URL),
    api: get(setup, 'servers.api', process.env.API_BASE_URL),
    stitcher: get(setup, 'servers.stitcher', process.env.STITCHER_BASE_URL),
    analytics: get(setup, 'servers.analytics', process.env.BEACONS_SERVER_URL),
  }),
);
